import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, map, exhaustMap, tap } from 'rxjs/operators';

import { of } from 'rxjs';
import { fetchTermPaymentRecords, fetchTermPaymentRecordsFail, fetchTermPaymentRecordsSuccess } from './report.action';


import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { TermPaymentTableService } from './term-payment-table.service';
import { DatatableService } from 'src/app/core/services/datatable.service';

@Injectable()
export class ReportRecordEffects {

    fetchData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchTermPaymentRecords),
            exhaustMap(() => {
                const url = 'report-term-payments'
                return this.crudServerService.fetchTableData(url, this.termPaymentTableService).pipe(
                    map( (response) => {
                        const data = response.data;

                        this.termPaymentTableService.page = data.pagination.current_page;
                        this.termPaymentTableService.lastPage = data.pagination.last_page;
                        this.termPaymentTableService.pagination = this.tableService.getPaginationArray(data.pagination.current_page, data.pagination.last_page);

                        this.termPaymentTableService.clubs = data.clubs;
                        this.termPaymentTableService.categories = data.categories;

                        this.alertService.triggerAlert(response.message, "success");

                        return fetchTermPaymentRecordsSuccess({termPaymentData: data.records, termPaymentsTotal: data.pagination.total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => fetchTermPaymentRecordsFail({ termPaymentError: error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private store: Store<RootReducerState>,
        private termPaymentTableService: TermPaymentTableService,
        private tableService: DatatableService
    ) { }

}